export const ARROW_SIZE = '48px';
